import { whatsapp } from '@/mocks/site';

/**
 * Construit un lien wa.me avec un message pré-rempli (une entrée par ligne).
 */
export function buildWhatsAppUrl(lines: string[]): string {
  const text = lines.filter((line) => line.trim() !== '').join('\n');
  return `https://wa.me/${whatsapp.number}?text=${encodeURIComponent(text)}`;
}